// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".br-gray-2[data-v-1d11caa7] {\n  border-right: 1px solid #adb5bd;\n}\n.full-quote-page-height[data-v-1d11caa7] {\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  min-height: calc(100vh - 52px - 52px - 20px) !important;\n}", ""]);
// Exports
module.exports = exports;
